/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum ShopifyDeliveryMethodFilter {
  SHIPPING="SHIPPING",
PICK_UP="PICK_UP",
RETAIL="RETAIL",
LOCAL="LOCAL",
PICKUP_POINT="PICKUP_POINT",
NONE="NONE"
}

/**
* ShopifyDeliveryMethodFilter
*/
export const ShopifyDeliveryMethodFilterEnumType = types.enumeration("ShopifyDeliveryMethodFilter", [
        "SHIPPING",
  "PICK_UP",
  "RETAIL",
  "LOCAL",
  "PICKUP_POINT",
  "NONE",
      ])
